function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#010101;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M6.5,2.1C6.5,0.9,5.6,0,4.6,0H1.9C0.8,0,0,0.9,0,2.1C0,3.1,0.9,4,1.9,4h2.6C5.6,4,6.5,3.1,6.5,2.1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M11.5,12.6c0-1.2-0.9-2.1-1.9-2.1H1.9c-1.2,0-1.9,0.9-1.9,2.1c0,1,0.9,1.9,1.9,1.9h7.6 C10.6,14.5,11.5,13.6,11.5,12.6z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M25,12.6c0-1.2-0.9-2.1-1.9-2.1h-7.6c-1.2,0-1.9,0.9-1.9,2.1c0,1,0.9,1.9,1.9,1.9h7.6 C24.1,14.5,25,13.6,25,12.6z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M25,2.1C25,0.9,24.1,0,23.1,0H10.4C9.3,0,8.5,0.9,8.5,2.1c0,1,0.9,1.9,1.9,1.9h12.6C24.1,4,25,3.1,25,2.1z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M6.5,23.1c0-1.2-0.9-2.1-1.9-2.1H1.9C0.8,21,0,21.9,0,23.1c0,1,0.9,1.9,1.9,1.9h2.6C5.6,25,6.5,24.1,6.5,23.1z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M25,23.1c0-1.2-0.9-2.1-1.9-2.1H10.4c-1.2,0-1.9,0.9-1.9,2.1c0,1,0.9,1.9,1.9,1.9h12.6C24.1,25,25,24.1,25,23.1 z"
});

var SvgMoreIcon = function SvgMoreIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoreIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more-icon.ce770f78.svg";
export { ForwardRef as ReactComponent };